// extracted by mini-css-extract-plugin
module.exports = {"loadingLayer":"Chart_loadingLayer__35u1u","spinner":"Chart_spinner__5yHiQ"};